const objectToString = Object.prototype.toString

/**
 * Trim strings in JSON-like request parameters without mutating form state.
 * Non-plain objects (such as FormData, File, Blob, and Date) are preserved.
 */
export function trimRequestParams(value) {
  if (typeof value === 'string') {
    return value.trim()
  }

  if (Array.isArray(value)) {
    return value.map(item => trimRequestParams(item))
  }

  if (objectToString.call(value) === '[object Object]') {
    return Object.keys(value).reduce((result, key) => {
      result[key] = trimRequestParams(value[key])
      return result
    }, {})
  }

  return value
}

export default trimRequestParams
